import React, {useEffect, useState} from 'react';
import {Session} from 'src/models';
import {startOfDay, endOfDay} from 'date-fns';
import HomeNotes from 'src/modules/practice-management/components/widgets/pmd-home-notes';

const NotesDue = ({notesDue, startDate, endDate, from = ''}: any) => {
  const [notesDueInRange, setNotesDueInRange] = useState<Session[]>([]);

  useEffect(() => {
    if (!notesDue) {
      return;
    }

    const start = startOfDay(new Date(startDate));
    const end = endOfDay(new Date(endDate));

    const isInRange = (session: Session) => {
      const sessionDate = new Date(session.date);
      return sessionDate >= start && sessionDate <= end;
    };

    const notes = notesDue.filter(isInRange);

    setNotesDueInRange(notes);
  }, [startDate, endDate, notesDue]);

  return <HomeNotes notesDue={notesDueInRange?.length} from={from} />;
};

export default NotesDue;
